import { IconWithCount } from "@src/appV2/redesign/system/ui-components";

interface WorkplaceReviewCommentRepliesCountIconProps {
  count: number;
}

export function WorkplaceReviewCommentRepliesCountIcon(
  props: WorkplaceReviewCommentRepliesCountIconProps
) {
  const { count } = props;

  return (
    <IconWithCount
      iconType="text-bubble"
      count={count}
      color={(theme) => theme.palette.text.tertiary}
    />
  );
}
